// ResizeObserver polyfill with error suppression
export function installResizeObserverPolyfill() {
  if (typeof window === 'undefined') return;
  
  console.log('[ResizeObserver Polyfill] Installing ResizeObserver error suppression...');
  
  // Store the original ResizeObserver if it exists
  const OriginalResizeObserver = window.ResizeObserver;
  
  if (!OriginalResizeObserver) {
    console.log('[ResizeObserver Polyfill] No ResizeObserver found, skipping patch');
    return;
  }
  
  // Create a debounce function to prevent loop errors
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  // Create our patched ResizeObserver
  class PatchedResizeObserver {
    constructor(callback) {
      // Debounce the callback to prevent rapid firing
      const debouncedCallback = debounce((entries, observer) => {
        // Use requestAnimationFrame to defer to next frame
        requestAnimationFrame(() => {
          try {
            callback(entries, observer);
          } catch (error) {
            // Silently ignore ResizeObserver errors
            if (!error.message?.includes('ResizeObserver')) {
              console.error('Non-ResizeObserver error:', error);
            }
          }
        });
      }, 0);
      
      try {
        this._observer = new OriginalResizeObserver(debouncedCallback);
      } catch (error) {
        console.log('[ResizeObserver Polyfill] Error creating observer:', error);
        // Create a minimal fallback
        this._observer = {
          observe: () => {},
          unobserve: () => {},
          disconnect: () => {}
        };
      }
    }
    
    observe(...args) {
      try {
        this._observer.observe(...args);
      } catch (error) {
        console.log('[ResizeObserver Polyfill] Error in observe:', error);
      }
    }
    
    unobserve(...args) {
      try {
        this._observer.unobserve(...args);
      } catch (error) {
        console.log('[ResizeObserver Polyfill] Error in unobserve:', error);
      }
    }
    
    disconnect() {
      try {
        this._observer.disconnect();
      } catch (error) {
        console.log('[ResizeObserver Polyfill] Error in disconnect:', error);
      }
    }
  }
  
  // Replace the global ResizeObserver
  window.ResizeObserver = PatchedResizeObserver;
  
  console.log('[ResizeObserver Polyfill] ResizeObserver patched successfully');
}